module.exports = __webpack_public_path__ + "static/media/eli_off.081548f8.png";